import { render, staticRenderFns } from "./WishlistArea.vue?vue&type=template&id=020474c4&"
import script from "./WishlistArea.vue?vue&type=script&lang=js&"
export * from "./WishlistArea.vue?vue&type=script&lang=js&"
import style0 from "./WishlistArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports